import { ca } from '@cian/analytics';

export const trackQRShow = (label: 'modal_qr_code' | 'carousel_qr_code') => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'hover',
    label,
  });
};

interface ICallButtonClickParams {
  action: 'Open_carousel_promo' | 'Open_detail_promo';
  customUrl: string;
  id: number;
}

export const trackCallButtonClick = ({ action, customUrl, id }: ICallButtonClickParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action,
    label: customUrl,
    products: [{ id }],
  });
};
